import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import React from "react";
import { toolTipContactDetails } from "../../functions/tooltips";
import { removePreviousInvite } from "./helperFunctions";

const PreviousInviteDropdown = ({
  employee,
  employeeUserId,
  row,
  userToken,
  dispatch,
  placements,
}) => {
  return (
    <Tooltip title={toolTipContactDetails(employee.user)} className="noPress">
      <div className="pl-3 pr-3 pb-1 row align-items-center">
        <div className="col-9 noPress">
          {employee.user.first_name} {employee.user.last_name}
        </div>
        <IconButton aria-label="filter list" className="noPress col-3">
          <DeleteIcon
            fontSize="small"
            onClick={() => {
              removePreviousInvite(
                employeeUserId,
                row /* Row is a placement */,
                userToken,
                dispatch,
                placements
              );
            }}
          />
        </IconButton>
      </div>
    </Tooltip>
  );
};

export default PreviousInviteDropdown;
